import styled from "styled-components";

// Medidas seguem os blocos já existentes da tela Compartilhar (títulos, .botao, IconWrapper)
// e o card da listagem de catálogos (raio 16px).
export const LinkAgrupamentoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  text-align: left;

  .cabecalho {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .titulo {
      color: ${(props) => props.theme.colors.secondary};
      font-weight: bold;
    }

    .descricao {
      color: ${(props) => props.theme.colors.tertiary};
    }
  }

  .aviso {
    color: ${(props) => props.theme.colors.tertiary};
  }

  .bloco {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .subtitulo {
    font-weight: bold;
    color: ${(props) => props.theme.colors.tertiary};
  }

  .rotulo {
    font-weight: bold;
    color: ${(props) => props.theme.colors.tertiary};

    .contador {
      font-weight: normal;
      color: ${(props) => props.theme.colors.placeholder};
    }
  }

  .linha-titulo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;

    .editar {
      cursor: pointer;
      color: ${(props) => props.theme.colors.tertiary};
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .link-gerado {
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.tertiary};
    border-radius: 18px;
    padding: 1rem 2rem;
    text-decoration: none;
    word-break: break-all;
  }

  .botao {
    cursor: pointer;
    text-align: center;
    white-space: nowrap;
    color: ${(props) => props.theme.colors.tertiary};
    background-color: ${(props) => props.theme.colors.elements};
    padding: 1rem 4rem;
    border-radius: 18px;

    &.desabilitado {
      cursor: not-allowed;
      opacity: 0.7;
    }
  }

  .linha-hash {
    display: flex;
    align-items: center;
    gap: 1rem;

    .prefixo {
      color: ${(props) => props.theme.colors.tertiary};
      white-space: nowrap;
    }

    .campo-hash {
      flex-grow: 1;
      min-width: 0;
    }
  }

  .dica {
    color: ${(props) => props.theme.colors.placeholder};
  }

  .erro {
    color: ${(props) => props.theme.colors.brandDanger};
  }

  .pesquisa-filtro {
    display: flex;
    gap: 2rem;
    align-items: center;

    .pesquisa {
      flex-grow: 1;
      min-width: 0;
    }

    /* Mesmo wrapper de Produtos e Cestas abandonadas: o FiltrosContainer tem
       width 100% e, sem ele, o filtro toma metade da linha da pesquisa */
    .filtro {
      display: flex;
      align-items: center;
      flex-shrink: 0;

      /* O botão fica no fim da linha: com o left: 0 padrão o dropdown (60rem) abre para fora
         da tela e cria rolagem lateral. Abaixo de 1024px o Filtros já vira modal centralizado. */
      @media (min-width: 1025px) {
        .containerDropdown > .dropdown {
          left: auto;
          right: 0;
          max-width: calc(100vw - 4rem);
        }
      }
    }
  }

  .grid-catalogos {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;

    @media (max-width: 535px) {
      grid-template-columns: 1fr;
    }
  }

  .card-catalogo {
    display: flex;
    flex-direction: column;
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 16px;
    overflow: hidden;
    border: 2px solid transparent;

    &.selecionado {
      border-color: ${(props) => props.theme.colors.secondary};
    }

    .banner {
      width: 100%;
      aspect-ratio: 2 / 1;
      object-fit: cover;
      border-radius: 16px;

      &.sem-banner {
        background-color: ${(props) => props.theme.colors.placeholder};
      }
    }

    .informacoes {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
      padding: 1rem 2rem 2rem;
      text-align: center;

      .nome {
        font-weight: bold;
        color: ${(props) => props.theme.colors.tertiary};
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      /* Nome e quantidade alinhados à esquerda; botão e "Gerenciado por" centralizados */
      .titulo-card {
        display: flex;
        flex-direction: column;
        align-self: stretch;
        text-align: left;
        margin-bottom: 1rem;

        /* Mesmo cinza da quantidade de produtos na listagem de catálogos */
        .quantidade {
          color: ${(props) => props.theme.colors.placeholder};
        }
      }

      .gerenciado {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 100%;
        margin-top: 1rem;
        color: ${(props) => props.theme.colors.placeholder};

        .usuario {
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      /* Card em white e botão em elements: o contrário deixa o texto do botão ilegível no card */
      .botao.remover {
        background-color: ${(props) => props.theme.colors.elements};
        padding: 0.5rem 2rem;
      }
    }
  }

  .acoes {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
    align-items: center;
  }

  .cancelar {
    cursor: pointer;
    text-align: center;
    margin-top: -2rem;
    color: ${(props) => props.theme.colors.placeholder};
    &:hover {
      text-decoration: underline;
    }
  }

  /* Cancelar edição e Excluir link lado a lado */
  .acoes-edicao {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4rem;
    margin-top: -2rem;

    .cancelar {
      margin-top: 0;
    }
  }

  .excluir {
    cursor: pointer;
    text-align: center;
    color: ${(props) => props.theme.colors.brandDanger};
    &:hover {
      text-decoration: underline;
    }

    &.desabilitado {
      cursor: not-allowed;
      opacity: 0.7;
    }
  }

  .canais {
    gap: 2rem;
    justify-content: space-between;
  }
`;
